import { render, staticRenderFns } from "./PunchClockShiftCalendar.vue?vue&type=template&id=4d7f2a50&scoped=true&"
import script from "./PunchClockShiftCalendar.vue?vue&type=script&setup=true&lang=js&"
export * from "./PunchClockShiftCalendar.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./PunchClockShiftCalendar.vue?vue&type=style&index=0&id=4d7f2a50&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d7f2a50",
  null
  
)

export default component.exports